import { render, staticRenderFns } from "./DashboardOperation.vue?vue&type=template&id=8b843770&scoped=true"
import script from "./DashboardOperation.vue?vue&type=script&lang=js"
export * from "./DashboardOperation.vue?vue&type=script&lang=js"
import style0 from "./DashboardOperation.vue?vue&type=style&index=0&id=8b843770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b843770",
  null
  
)

export default component.exports